module.exports = __webpack_public_path__ + "static/media/07_sydney-coquitlam.8ff9f2bf.jpg";